import styled from 'styled-components';

export const ContainerModal = styled.div`
  display: flex;

  h3 {
    font-size: 20px;
    color: var(--primary-color);
  }

  p {
    font-weight: bold;
  }
`;
